import React from "react";
import {
  FormattedMessage,
  injectIntl,
  WrappedComponentProps,
} from "react-intl";
import cssStyles from "./OverviewPageContent.module.scss";
import Cards from "./data/Cards.json";
import NavCategories from "./data/NavCategories.json";
import LanguageDropdown from "../../GlobalComponents/LanguageDropdown/LanguageDropdown";
import OverviewHeader from "./components/Header/OverviewHeader";
import OverviewCard from "./components/OverviewCard/OverviewCard";
import { getAllQueryParameters } from "../../Utilities/Url";
import Footer from "../../GlobalComponents/Footer/Footer";
import UsefulLinks from "./components/UsefulLinks/UsefulLinks";
import { isInTeams } from "../../Utilities/TeamsCheck";

interface OverviewpageContentProps {}

interface OverviewpageContentState {
  filteredCards: any[];
  selectedNavCategory: number;
  headerButtonToggle: string;
}

const OverviewpageContent: React.FC<
  OverviewpageContentProps & WrappedComponentProps
> = (props) => {
  const [filteredCards, setFilteredCards] = React.useState<any[]>([]);
  const [selectedNavCategory, setSelectedNavCategory] =
    React.useState<number>(0);
  const [headerButtonToggle, setHeaderButtonToggle] =
    React.useState<string>("overview");

  React.useEffect(() => {
    filterCards("all");
  }, []);

  const filterCards = (filterFor: string) => {
    let cards = [];
    if (filterFor === "all") {
      cards = Cards.Overview;
    } else {
      cards = Cards.Overview.filter(
        (card) => card.categoryId === filterFor
      );
    }
    setFilteredCards(cards);
  };

  const handleNavCategoryClick = (index: number) => {
    setSelectedNavCategory(index);
    filterCards(
      NavCategories[index].id.substring(
        NavCategories[index].id.indexOf(".") + 1
      )
    );
  };

  const handleHeaderButtonToggle = (toggle: string) => {
    setHeaderButtonToggle(toggle);
  };

  return (
    <div className={cssStyles.OverviewpageContent}>
      {/* <PagesNavBar targetUrl={props.originUrl} theme={props.theme} show={true}></PagesNavBar> */}
      <div className={cssStyles.Content}>
        {!isInTeams() && (
          <div className={cssStyles.Topbar}>
            <div>
              <h6>Solutions2Share</h6>
              <div
                className={[
                  cssStyles.OverviewPageTitle,
                  cssStyles.OverviewPageTitleDark,
                ].join(" ")}
              >
                {/* <FormattedMessage id='Overview.Title' defaultMessage='Overview' /> */}
                <button
                  className={
                    headerButtonToggle === "overview" && cssStyles.activeTab
                  }
                  onClick={() => handleHeaderButtonToggle("overview")}
                >
                  Overview
                </button>
                <button
                  className={
                    headerButtonToggle === "usefulLinks" && cssStyles.activeTab
                  }
                  onClick={() => handleHeaderButtonToggle("usefulLinks")}
                >
                  Useful links
                </button>
              </div>
            </div>
            <LanguageDropdown></LanguageDropdown>
          </div>
        )}
        <OverviewHeader></OverviewHeader>
        {headerButtonToggle === "overview" && (
          <div className={cssStyles.navBar}>
            <div className={cssStyles.navBarTitle}>Apps</div>
            <div className={cssStyles.navBarCategoryContainer}>
              {NavCategories.map((navCategory, index) => (
                <div
                  onClick={
                    index !== selectedNavCategory
                      ? () => handleNavCategoryClick(index)
                      : null
                  }
                  className={cssStyles.navBarCategoryItem}
                  id={index === selectedNavCategory ? cssStyles.selectedNavCategory : null}
                >
                  <FormattedMessage
                    id={navCategory.id}
                    defaultMessage={navCategory.id}
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {headerButtonToggle === "overview" ? (
          <div className={cssStyles.OverviewCardContainer}>
            {filteredCards.map((card) => (
              <OverviewCard
                TargetUrl={card.targetUrl}
                LinkParams={getAllQueryParameters(window.location.href)}
                TitleTranslationId={"Overview.Card." + card.name + ".Title"}
                DescriptionTranslationId={
                  "Overview.Card." + card.name + ".Description"
                }
                CategoryTranslationId={"Common." + card.categoryId}
                Company={card.company}
                Image={"/img/OverviewPage/" + card.imageName}
              />
            ))}
          </div>
        ) : (
          <div className={cssStyles.OverviewCardsBlock}>
            <UsefulLinks />
          </div>
        )}
      </div>
      <Footer></Footer>
    </div>
  );
};

export default injectIntl(OverviewpageContent);
